import React, { useState, useEffect } from 'react';
import SearchWidget from '../../../shared/components/SearchWidget';
import tourvisorAPI from '../../api/tourvisorAPI';
import SearchWidgetOpen from '../../../shared/components/SearchWidgetOpen';

const Operator = ({
  value = [],
  onChoose,
  country,
  isOpen = true,
  onHide,
  isOperatorHidden,
  ...rest
}) => {
  const [operators, setOperators] = useState(value);
  let [items, setItems] = useState([]);
  const [title, setTitle] = useState('Любой');
  useEffect(() => {
    // Update the document title using the browser API
    items = getOperators({ flycountry: country });
  }, [country]);

  const getOperators = async (params) => {
    let requestQuery = new URLSearchParams(params).toString();
    const res = await tourvisorAPI.dics('operator', requestQuery);
    const operatorsList = res.lists.operators.operator;
    const operatorsListFixed = operatorsList.map((operator) => {
      operator.name = operator.name.replace('(TUI)', '');
      return operator;
    });
    setItems(operatorsList);
  };

  const setTouroperatorsOnChoose = (v) => {
    const index = value.indexOf(v);
    const oper = items.find((item) => item.id == v);

    if (index !== -1) {
      value.splice(index, 1);
    } else {
      value.push(v);
    }
    if (oper && value.length == 1) {
      const current_oper = items.find((item) => item.id == value);
      setTitle(current_oper.name);
    } else if (oper && value.length < 5) {
      setTitle(`Выбрано ${value.length}`);
    } else if (oper && value.length > 4) {
      setTitle(`Выбрано ${value.length}`);
    } else if (value.length) {
      setTitle(`Любой`);
    }

    setOperators(value, onChoose(operators));
  };
  return isOpen ? (
    <SearchWidgetOpen
      type="multiselect"
      label="туроператор"
      title={`${title}`}
      items={items}
      value={operators}
      isHidden={true}
      onHide={onHide}
      width={'unset'}
      cssClass={'operators'}
      onChoose={setTouroperatorsOnChoose}
    />
  ) : (
    <SearchWidget
      cssClass={'operators'}
      type="multiselect"
      label="туроператор"
      title={`${title !== 'Любой' ? title : 'Любой туроператор'}`}
      items={items}
      onHide={onHide}
      value={operators}
      isOperatorHidden={isOperatorHidden}
      onChoose={setTouroperatorsOnChoose}
    />
  );
};

export default Operator;
